import { useRecoilValue } from "recoil";
import { totalState } from "../../store/totalState";
import { useCustomPagination } from "../useCustomPagenation";
import { useUpdateTotal } from "../useUpdateTotal";
import { useFetchManLaboSurveyAnswerTextsWithLineAccountsPerPage } from "./useFetchManLaboSurveyAnswerTextsWithLineAccountsPerPage";

export const useFetchPaginateManLaboSurveyAnswerTextsWithLineAccounts = (restaurantId: string) => {
  const total = useRecoilValue(totalState);
  const { pages, pagesCount, currentPage, setCurrentPage, pageSize } = useCustomPagination(total, 20);
  const { manLaboSurveyAnswerTextsWithLineAccountsPerPage, isLoading } = useFetchManLaboSurveyAnswerTextsWithLineAccountsPerPage(restaurantId, pageSize, currentPage)
  useUpdateTotal(manLaboSurveyAnswerTextsWithLineAccountsPerPage);

  return { manLaboSurveyAnswerTextsWithLineAccountsPerPage, isLoading, pages, pagesCount, currentPage, setCurrentPage };
};